import FormErrorMessage from '@/app/common/components/FormErrorMessage'
import { Input } from '@/app/common/components/Input'
import { Label } from '@/shad/ui/label'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { FilingStatusForm } from './FilingStatus'
import { useTranslation } from 'react-i18next'

type SpouseInformationProps = {
  register: UseFormRegister<FilingStatusForm>
  errors?: FieldErrors<FilingStatusForm>
}

export function SpouseInformation({
  register,
  errors,
}: SpouseInformationProps) {
  const {t} = useTranslation()

  return (
    <div className="space-y-2">
      <div className="space-y-1">
        <Label>{t("spouse_name")}</Label>
        <Input
          {...register('spouseFirstName')} // Add this field to your FormData type
        />
      </div>
      <div className="space-y-1">
        <Label>{t("spouse_last_name")}</Label>
        <Input
          {...register('spouseLastName')} // Add this field to your FormData type
        />
      </div>
      {errors?.spouseFirstName || errors?.spouseLastName ? (
        <FormErrorMessage
          message={
            errors?.spouseFirstName?.message || errors?.spouseLastName?.message
          }
        />
      ) : null}
    </div>
  )
}
